import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export const HrefLink = ({ href, children }: { href: string; children: ReactNode }) => (
  <Link to={href}>{children}</Link>
);

/**
 * Drylus 7 types the `linkComponent` prop (DropdownLink, TabMenuLink...) as `ReactNode`,
 * but renders it with `React.createElement(linkComponent, { href }, children)`, so it must be
 * a component. @types/react 16 let a component pass as a ReactNode (ReactNode included `{}`);
 * @types/react 18 doesn't. This keeps the one cast forced by that typing in a single place.
 */
export const DrylusHrefLink = HrefLink as unknown as ReactNode;
